export default {
  methods: {
    setupLogin(data) {
      this.$store.commit('auth/setUserData', data)
      localStorage.setItem('role', data?.role)
      localStorage.setItem('permissions', JSON.stringify(data?.permissions))
      const permissions = this.$store.getters['auth/formattedPermissions']
      if (permissions) {
        this.$ability.update(permissions)
      }
      this.showSuccess('Login Successful, We are loading some additional data...')
      // this.$router.push({ name: 'home' })
      window.location = '/'
    },
  },
}
